

export const UPDATE_MY_DETAILS = "myDetails/UPDATE_MY_DETAILS";
export const UPDATE_MY_DETAILS_COMPLETED = "myDetails/UPDATE_MY_DETAILS_COMPLETED";
export const UPDATE_MY_DETAILS_FAILED = "myDetails/UPDATE_MY_DETAILS_FAILED";

